<div class="header">
  <div class="top-row">
    <div class="progress-indicator">
      <div class="bar" [class.active]="currentStep() >= 1"></div>
      <div class="bar" [class.active]="currentStep() >= 2"></div>
      <div class="bar" [class.active]="currentStep() >= 3"></div>
    </div>
    <button mat-icon-button mat-dialog-close>
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <h1>{{ 'complete-profile.title' | translate }}</h1>
  <p class="subtitle">{{ subtitleKey() | translate }}</p>
</div>
<mat-dialog-content [plLoader]="loaderTask">
  @if (loaded()) {
    @switch (currentStep()) {
      @case (1) {
        <cloudlab-complete-profile-step1 />
      }
      @case (2) {
        <cloudlab-complete-profile-step2 />
      }
      @case (3) {
        <cloudlab-complete-profile-step3 />
      }
    }
  }
</mat-dialog-content>
<div class="btn-container flex-column justify-center align-center">
  @if (isLastStep()) {
    <button mat-button
            class="save tertiary-action"
            data-testid="done-btn"
            [disabled]="!isCurrentStepValid()"
            (click)="done()">
      {{ 'complete-profile.done' | translate }}
    </button>
  } @else {
    <button mat-button
            class="save tertiary-action"
            data-testid="next-btn"
            [disabled]="!isCurrentStepValid()"
            (click)="next()">
      {{ 'complete-profile.next' | translate }}
      <mat-icon iconPositionEnd svgIcon="keyboard_arrow_right"></mat-icon>
    </button>
  }
  <div class="nav-row flex-row justify-center">
    @if (currentStep() > 1) {
      <button mat-button
              data-testid="back-btn"
              (click)="back()">
        {{ 'complete-profile.back' | translate }}
      </button>
    }
    @if (!isLastStep()) {
      <button mat-button
              class="skip-for-now-btn"
              data-testid="skip-for-now-btn"
              (click)="dialogRef.close()">
        {{ 'complete-profile.skip' | translate }}
      </button>
    }
  </div>
</div>
